import Vue from "vue";
import Vuex from "vuex";
import { getField, updateField } from "vuex-map-fields";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [],
  state: {
    matchMediaString: "(max-width: 900px)",
    mapConfig: {
      zoom: null,
      reportedZoom: 11,
      center: null,
      reportedCenter: { lat: -41.22, lng: 175.0 },
      originalCenter: { lat: -41.22, lng: 175.0 },
      originalZoom: 11,
    },
    filterOption: "current",
    filterMarkerSelectedLocation: null,
    searchText: "",
    outagePageView: "map",
    plannedOutages: [],
    unplannedOutages: [],
    cmsContent: {
      featuredImages: [],
      recentHelpContent: "",
      alternateDateHelpContent: "",
      defaultReasonForCancellation: "",
      defaultReasonForAlternateDate: "",
      toastMessage: [],
    },
  },
  getters: {
    getField,
    getMarkerIcon: (state) => (outage) => {
      return outage.type === "planned"
        ? "_resources/app/client/assets/icons/outages-map/planned-outage-icon.svg"
        : "_resources/app/client/assets/icons/outages-map/unplanned-outage-icon.svg";
    },
    getAllOutagesByTimeFilter: (state) => {
      //get both plannedOutages and unplannedOutages and filter by filterOption
      return state.plannedOutages
        .concat(state.unplannedOutages)
        .filter((outage) => {
          let match = false;
          if (outage.status == "Cancelled") {
            match = state.filterOption === "scheduled";
          } else {
            match = state.filterOption === outage.timeBasedStatus;
          }
          return match;
        });
    },
    //get all outages and sort by start date
    getAllFilteredOutages: (state, getters) => {
      return getters.getFilteredPlannedOutages
        .concat(getters.getFilteredUnPlannedOutages)
        .sort((a, b) => {
          let aStartDateTime = '';
          let bStartDateTime = '';

          if(a.type == 'planned'){
            aStartDateTime = a.outageStartDateTime;

            //if we it has been flagged to use alternate date and it's set use it
            if (
              a.useAlternateDate &&
              a.alternateStartDateTime
            ) {
              aStartDateTime = a.alternateStartDateTime;
            }
          } else {
            aStartDateTime = a.timeOfFault;
          }

          // let unplannedOutageStartDateTime = unplannedOutage.timeOfFault;
          
          if(b.type == 'planned'){
            bStartDateTime = b.outageStartDateTime;

            //if we it has been flagged to use alternate date and it's set use it
            if (
              b.useAlternateDate &&
              b.alternateStartDateTime
            ) {
              bStartDateTime = b.alternateStartDateTime;
            }
          } else {
            bStartDateTime = b.timeOfFault;
          }

          if(state.filterOption === "scheduled"){
            return (
              new Date(aStartDateTime) -
              new Date(bStartDateTime)
            );
          } else {
            return (
              new Date(bStartDateTime) -
              new Date(aStartDateTime)
            );
          }
        });
    },
    getFilteredUnPlannedOutages: (state) => {
      return state.unplannedOutages.filter((outage) => {
        if (!outage.location.lat && !outage.location.lng) {
          return false;
        }

        //match on current/recent/scheduled
        let match = state.filterOption === outage.timeBasedStatus;

        // If we don't have a match return early,
        // or if the search text is empty then return the match
        if (
          !match ||
          (state.searchText === "" &&
            state.filterMarkerSelectedLocation == null)
        ) {
          return match;
        }

        //if we made it here then we have a match and search text is not empty so then reset back to false
        match = false;

        //If we have a match and search text is not empty then filter by search text
        let searchLowerCase = state.searchText.toLowerCase();
        // prettier-ignore
        if (
          outage.id.toLowerCase().includes(searchLowerCase) ||
          outage.suburbsText.toLowerCase().includes(searchLowerCase) ||
          outage.lastUpdatedComments.toLowerCase().includes(searchLowerCase) ||
          outage.areas.some((area) =>
            area.suburb.toLowerCase().includes(searchLowerCase) ||
            area.street.toLowerCase().includes(searchLowerCase) || 
            area.city.toLowerCase().includes(searchLowerCase) || 
            area.region.toLowerCase().includes(searchLowerCase) 
          )
        ) {
          match = true;
        }

        //if we have a markter selected then filter all other outages with the exact same location
        //this is for stacked pins
        if (state.filterMarkerSelectedLocation != null) {
          match = false;

          if (
            state.filterMarkerSelectedLocation.lat === outage.location.lat &&
            state.filterMarkerSelectedLocation.lng === outage.location.lng
          ) {
            match = true;
          }
        }

        return match;
      });
    },
    getFilteredPlannedOutages: (state) => {
      return state.plannedOutages.filter((outage) => {
        //First filter by filterOption current, recent, scheduled

        //if we don't have a valid lat and long we can't use it
        if (!outage.location.lat && !outage.location.lng) {
          return false;
        }

        let startDateTime = outage.outageStartDateTime;
        let endDateTime = outage.outageEndDateTime;
        //if we it has been flagged to use alternate date and it's set use it
        if (
          outage.useAlternateDate &&
          outage.alternateStartDateTime &&
          outage.alternateEndDateTime
        ) {
          startDateTime = outage.alternateStartDateTime;
          endDateTime = outage.alternateEndDateTime;
        }

        //match on current/recent/scheduled
        let match = false;
        if (outage.status == "Cancelled") {
          match = state.filterOption === "scheduled";
        } else {
          match = state.filterOption === outage.timeBasedStatus;
        }

        // If we don't have a match return early,
        // or if the search text is empty then return the match &&

        if (
          !match ||
          (state.searchText === "" &&
            state.filterMarkerSelectedLocation == null)
        ) {
          return match;
        }

        //if we made it here then we have a match and search text is not empty so then reset back to false
        match = false;

        //If we have a match and search text is not empty then filter by search text
        let searchLowerCase = state.searchText.toLowerCase();
        // prettier-ignore
        if (
          outage.distributorEventNumber.toLowerCase().includes(searchLowerCase) ||
          outage.suburbsText.toLowerCase().includes(searchLowerCase) ||
          outage.reasonForOutage.toLowerCase().includes(searchLowerCase) ||
          outage.reasonForCancellation.toLowerCase().includes(searchLowerCase) ||
          outage.areas.some((area) =>
            area.suburb.toLowerCase().includes(searchLowerCase) ||
            area.street.toLowerCase().includes(searchLowerCase)
          )
        ) {
          match = true;
        }

        //if we have a markter selected then filter all other outages with the exact same location
        //this is for stacked pins
        if (state.filterMarkerSelectedLocation != null) {
          match = false;

          if (
            state.filterMarkerSelectedLocation.lat === outage.location.lat &&
            state.filterMarkerSelectedLocation.lng === outage.location.lng
          ) {
            match = true;
          }
        }

        return match;
      });
    },
  },
  mutations: {
    updateField,
    resetMapView(state) {
      state.mapConfig.zoom = state.mapConfig.originalZoom;
      state.mapConfig.reportedZoom = state.mapConfig.originalZoom;

      state.mapConfig.reportedCenter = state.mapConfig.originalCenter;
      state.mapConfig.center = state.mapConfig.originalCenter;
    },
    updateOutagePageView(state, view) {
      state.outagePageView = view;
      console.log("state.outagePageView", state.outagePageView);
    },
    clearAllFilters(state) {
      state.filterMarkerSelectedLocation = null;
      state.searchText = "";
    },
    clearMarkerFilter(state) {
      state.filterMarkerSelectedLocation = null;
    },
  },
  actions: {
    async getAllOutages({ state, commit }) {
      return await axios
        .get(
          window.location.origin + window.location.pathname + "/getalloutages"
        )
        .then((res) => {
          commit("updateField", {
            path: "plannedOutages",
            value: res.data.plannedOutages,
          });
          commit("updateField", {
            path: "unplannedOutages",
            value: res.data.unplannedOutages,
          });
        });
    },
  },
});
